import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b648efca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Forget Password", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Change Password", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Send Link", -1))

import { ref, getCurrentInstance, watch, Ref } from 'vue'
import { useRouter } from 'vue-router'
import { 
    NCard, NSpace, NButton, NForm, NFormItem, FormRules, FormItemRule, FormInst, NInput
} from 'naive-ui'
import { ValidateError } from 'async-validator'
import axios from 'axios'
import store from '@/store'
import { ResetPasswordModel, SendResetPasswordModel } from '@/types/ForgetPassword'
import { FormValidateCallback } from 'naive-ui/lib/form/src/interface'

export default /*#__PURE__*/_defineComponent({
  __name: 'ForgetPassword',
  props: {
    token: null
  },
  setup(__props: any) {

const props = __props as {
    token?: string
}

const router = useRouter()
const app = getCurrentInstance()
const message = app!.appContext.config.globalProperties.message


const reset = ref(false)
const sendReset = ref(!props.token)

if (props.token) {
    axios.get(`/api/auth/forget-password/check/${props.token}/`)
    .then((response) => {
        reset.value = true
    })
    .catch((error) => {
        let messageContent = 'A problem is occurred when generating reset password form'
        if ([404, 400].includes(error.response.status)) {
            messageContent = 'Reset password link is expired or invalid'
        }
        message.error(messageContent, {showIcon: true, closable: true})
        router.push('/logout')
    })
}

const resetLoading = ref(false)
const sendResetLoading = ref(false)

const resetForm = ref<FormInst | null>(null)
const sendResetForm = ref<FormInst | null>(null)
const resetModel = ref<ResetPasswordModel>({})
const sendResetModel = ref<SendResetPasswordModel>({})

const resetRules: FormRules = {    
    password: [
        {
            required: true,
            message: "Password is required",
            trigger: ['change']
        },
        {
            validator (rule: FormItemRule, value: string) {
                return value.length >= 8;
            },
            message: "Password must be at least 8 characters",
            trigger: ['change']
        },
        {
            validator (rule: FormItemRule, value: string) {
                return /\d/.test(value)
            },
            message: "Password must have at least a number",
            trigger: ['change']
        },
        {
            validator (rule: FormItemRule, value: string) {
                return /[a-zA-Z]/.test(value)
            },
            message: "Password must have at least an alphabet character",
            trigger: ['change']
        },
    ],
    confirmPassword: [
        {
            required: true,
            message: 'Confirm password is required',
            trigger: ['change']
        },
        {
            validator (rule: FormItemRule, value: string): boolean {
                return value === resetModel.value.password
            },
            message: 'Passwords are different',
            trigger: ['change', 'password-input']
        }
    ],
}
const sendResetRules: FormRules = {
    email: [
        {
            required: true,
            message: 'Email is required',
            trigger: ['change']
        },
        {
            validator (rule: FormItemRule, value: string) {
                return /\b[\w.\-+]+@[\w.-]+.\w{2,4}\b/.test(value)
            },
            message: 'Email is invalid',
            trigger: ['change']
        }
    ],
}

function handleValidate(e: MouseEvent, form: Ref<FormInst | null>, fallbackFun: FormValidateCallback) {
    e.preventDefault()
    form.value!.validate(fallbackFun).catch(error => {
        message.error('Form is invalid', {showIcon: true, closable: true})
        resetLoading.value = false
    })
}

function resetHandleValidate(e: MouseEvent) {
    handleValidate(e, resetForm, resetValidateForm)
}
function sendResetHandleValidate(e: MouseEvent) {
    handleValidate(e, sendResetForm, sendResetValidateForm)
}
function resetValidateForm(errors: ValidateError[][] | undefined) {
    if (!errors) {
        resetLoading.value = true
        resetModel.value.token = props.token
        axios.post('/api/auth/forget-password/', resetModel.value)
            .then((response) => {
                message.success("Password is successfully reset! Please login", {showIcon: true, closable: true})
                router.push("/logout")
            })
            .catch((error) => {
                let messageContent = "A problem is occurred when resetting password"
                if ('message' in (error.response.data || {})) {
                    messageContent = error.response.data.message
                }
                message.error(messageContent, {showIcon: true, closable: true})
                resetLoading.value = false
            })
    } 
}

function sendResetValidateForm(errors: ValidateError[][] | undefined) {
    if (!errors) {
        sendResetLoading.value = true
        resetModel.value.token = props.token
        axios.get(`/api/auth/forget-password/${sendResetModel.value.email}/`)
            .then((response) => {
                message.success("Link reset password is successfully sent!", {showIcon: true, closable: true})
                router.push("/logout")
            })
            .catch((error) => {
                let messageContent = "A problem is occurred when sending reset password link"
                if (error.response.status == 404) {
                    messageContent = "No user found with this email address"
                }
                message.error(messageContent, {showIcon: true, closable: true})
                sendResetLoading.value = false
            })
    } 
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NCard), { size: "small" }, {
      header: _withCtx(() => [
        _createVNode(_unref(NSpace), {
          id: "form-title",
          vertical: "",
          align: "center",
          size: "small"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (reset.value)
          ? (_openBlock(), _createBlock(_unref(NForm), {
              key: 0,
              ref_key: "resetForm",
              ref: resetForm,
              model: resetModel.value,
              rules: resetRules
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NFormItem), {
                  id: "passwordForm",
                  path: "password",
                  first: "",
                  label: "Password"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      id: "password",
                      value: resetModel.value.password,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((resetModel.value.password) = $event)),
                      type: "password",
                      "show-password-on": "mousedown",
                      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                      size: "large"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NFormItem), {
                  id: "confirmPasswordForm",
                  ref: "passwordFormItem",
                  path: "confirmPassword",
                  first: "",
                  label: "Confirm Password"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      id: "confirmPassword",
                      value: resetModel.value.confirmPassword,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((resetModel.value.confirmPassword) = $event)),
                      disabled: !resetModel.value.password,
                      type: "password",
                      "show-password-on": "mousedown",
                      size: "large"
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 512),
                _createVNode(_unref(NButton), {
                  id: "submitBtn",
                  loading: resetLoading.value,
                  type: "primary",
                  "attr-type": "submit",
                  onClick: resetHandleValidate,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true),
        (sendReset.value)
          ? (_openBlock(), _createBlock(_unref(NForm), {
              key: 1,
              ref_key: "sendResetForm",
              ref: sendResetForm,
              model: sendResetModel.value,
              rules: sendResetRules
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NFormItem), {
                  id: "emailForm",
                  path: "email",
                  first: "",
                  label: "Email"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      id: "email",
                      value: sendResetModel.value.email,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((sendResetModel.value.email) = $event)),
                      size: "large"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NButton), {
                  id: "submitBtn",
                  loading: sendResetLoading.value,
                  type: "primary",
                  "attr-type": "submit",
                  onClick: sendResetHandleValidate,
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})